// Function to scroll to the target element with an offset
function scrollToElementWithOffset(targetElement, offset) {
    if (targetElement) {
      const offsetTop = targetElement.offsetTop - offset;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  }

  function getOffset() {
    var navheight = 0;
    var offsetplus = 30;

    const siteHeader = document.querySelector('.site-header');
    if (document.body.classList.contains('fixed-nav')) {
        navheight = siteHeader.offsetHeight;
    }

    return navheight + offsetplus;
  }

  // Function to handle anchor link clicks
  function handleAnchorLinkClick(event) {
    event.preventDefault();
    const targetId = this.getAttribute('href').substr(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
        var offset = getOffset();
        scrollToElementWithOffset(targetElement, offset); // Adjust the offset as needed

        // Update the URL with the anchor link
        history.pushState(null, '', '#' + targetId);
    }
  }

  // Add event listener for all anchor link clicks
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', handleAnchorLinkClick);
  });

  // Add event listener for page load with an anchor link
  window.addEventListener('load', function () {
    const hash = window.location.hash;
    if (hash) {
      const targetId = hash.substr(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        var offset = getOffset();
        scrollToElementWithOffset(targetElement, offset); // Adjust the offset as needed
      }
    }
  });

